import React from 'react';
import { Truck } from 'lucide-react';

const TrustedPartners = () => {
  const partners = [
    { name: 'TRUCK TRANSPORTATION', id: 1 },
    { name: 'TRUCK TRANSPORTATION', id: 2 },
    { name: 'TRUCK TRANSPORTATION', id: 3 },
    { name: 'TRUCK TRANSPORTATION', id: 4 }
  ];

  return (
    <section className="py-16 px-6 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-4xl font-bold text-center mb-12 text-gray-900">
          Some of Our Trusted Partners
        </h2>
        
        <div className="bg-gradient-to-br from-gray-700 to-gray-800 py-12 px-6 rounded-3xl">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {partners.map((partner, index) => (
              <div key={index} className="flex flex-col items-center justify-center space-y-2">
                <Truck className="w-16 h-16 text-gray-400" />
                <p className="text-gray-400 text-xs font-semibold text-center uppercase tracking-wider">
                  {partner.name}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustedPartners;
